import React, { Component, Fragment } from "react";
import axios from "../../../containers/api";
import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Badge, Modal, ModalHeader, ModalBody, Alert, ModalFooter } from "reactstrap";
import { Colxx} from "../../../components/common/CustomBootstrap";
import {Table} from "../../../components/table/Table";
import DatePicker from "react-modern-calendar-datepicker";
import Config from "../../../constants/config";
import {convertDate, getLoaderTypes, showCatchError, toCurrency, toEnglishNumbers} from "../../../helpers/Utils";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import DriverInformation from "../../../components/admin/DriverInformation";
import ChargeDriver from "../../../components/admin/ChargeDriver";
import PersonAccountActivities from "../../../components/admin/PersonAccountActivities";
import ChangePassDriver from "../../../components/admin/ChangePassDriver";
import DriverRecentActivity from "../../../components/admin/DriverRecentActivity";
import DriverToFreighter from "../../../components/admin/DriverToFreighter";
import AddFreighter from "../../../components/admin/AddFreighter";
import UpdateDriverTurn from "../../../components/admin/UpdateDriverTurn";

export default class DriverSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            member: JSON.parse(localStorage.getItem("member")),
            collapse: true,
            isSearch: false,
            ChargeModal: false,
            ChangePassModal: false,
            UpdateTurnModal: false,
            ShowAccountActivityModal: false,
            DriverInformationModal: false,
            oneDriver: {},
            DriverId: null,
            errors: [],
            driverSearchTypes: [
                { value: 1, text: 'کد ملی راننده' },
                { value: 2, text: 'شماره هوشمنده راننده' },
                { value: 6, text: 'شماره هوشمنده ناوگان' },
                { value: 3, text: 'نام راننده' },
                { value: 4, text: 'فامیل راننده' },
                { value: 5, text: 'تلفن همراه' },

            ],
            selectedDriverSearchType: { value: 1, text: 'کد ملی راننده' },
            driverSearchResult: [],
            LoaderType: null,
            DriverRegisterDate: null,
            ShowRecentActivityModal: false,
            ShowDriverToFreighterModal: false,
            ShowAddFreighterModal: false,
            recentActivityData: [],
            DriverToFreighterData: [],
            search: "",
            loaderTypes: [],
            ShowImageModal: false,
            ShowImage: [],
            DriverRateList: [],
            DriverRateListMsg: "",
            DriverRateModal: false,
            AvrageRate: 0 
        };
    }

    componentDidMount() {
      //  this.CheckMemberTypeIsAdmin();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    try {
                        this.getLoaderTypesApi().then(r => console.log(r));
                    } catch (err) {
                        console.log(err);
                    }
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    async getLoaderTypesApi() {
        try {
            await getLoaderTypes()
                .then((res) => this.setState({loaderTypes: res}) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }

    reset = () => {
        this.setState({
            LoaderType: null,
            search: "",
            DriverRegisterDate: null,
        });
    };

    validateInputData = (isSearch) => {
        let error = [];
        if (this.state.search === null || this.state.search === "" || this.state.search === undefined) {
            error.push("لطفا فیلد جستجو را وارد کنید .");
        }

        this.setState({ errors: error });
        if (error.length === 0) {
            this.searchForDriver(isSearch);
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    searchForDriver = (isSearch) => {
        let url;
        switch (this.state.selectedDriverSearchType.value) {
            case 1:
                url = 'api/v1/drivers/GetDriverInfoByNationalId/';
                break;
            case 2:
                url = 'api/v1/drivers/DriverInfoByCardNumber/';
                break;
            case 3:
                url = 'api/v1/drivers/GetDriverInfoByName/';
                break;
            case 4:
                url = 'api/v1/drivers/GetDriverInfoByFamily/';
                break;
            case 5:
                url = 'api/v1/drivers/GetDriverInfoByMobile/';
                break;
            case 6:
                url = 'api/v1/drivers/GetDriverInfoByFreighterCardNumber/';
                break;
        }

        this.searchDriverBy(url, isSearch);
    };
    searchDriverBy = (url, isSearch) => {
        this.props.showSpinner();
        let url1 = url + toEnglishNumbers(this.state.search)
        axios.get(url + toEnglishNumbers(this.state.search))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("راننده‌ای با مشخصات مورد نظر یافت نشد", "warning");
                } else {
                    if (isSearch) {
                        this.props.showAlert("جستجو موفقیت‌آمیز بود", "success");
                        this.setState({collapse: false});
                    }
                    this.setState({driverSearchResult: res.data.data});
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    searchDriverByLoaderTypes = (isSearch) => {
        this.props.showSpinner();
        axios.get('api/DriverApi/searchDriverByLoaderTypes?LoaderTypeId=' + this.state.LoaderType.loaderTypeID)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data === null || res.data.length === 0) {
                    this.setState({driverSearchResult: []});
                    this.props.showAlert("راننده‌ای با کشنده مورد نظر یافت نشد", "error");
                } else {
                    if (isSearch) {
                        this.props.showAlert("جستجو موفقیت آمیز بود", "success");
                        this.setState({collapse: false});
                    }
                    this.setState({driverSearchResult: res.data});
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    LogOutDriver = (id, isSearch) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.get('api/DriverApi/LogOutDriver?id=' + id)
            .then(() => {
                this.props.showAlert("راننده با موفقیت از سیستم خارج شد", 'success');
                this.searchForDriver(isSearch);
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    Active = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.patch('api/v1/drivers/ActiveDriver/' + id)
            .then(() => {
                this.props.showAlert("راننده با موفقیت فعال شد", 'success');
                this.searchForDriver(false);
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    
    Deactive = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.patch('api/v1/drivers/DeactiveDriver/' + id)
            .then(() => {
                this.props.showAlert("راننده با موفقیت غیر فعال شد", 'success');
                this.searchForDriver(false);
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    NativeDriver = (id,IsNative) => {
        this.props.closeSweetAlert();
    this.props.showSpinner();
        let api = "NativeDriver";
        if (IsNative === false)
            api = "NonNativeDriver";
        axios.post('api/v1/drivers/' + api + '?driverId=' + id, null)
            .then((res) => {
                this.props.showAlert(res.data.message, "success");;
                this.searchForDriver(false);
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    RemovePhoneId = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('api/v1/drivers/RemovePhoneId?Id=' + id, null)
            .then(() => {
                this.props.showAlert("شناسه با موفقیت حذف شد", 'success');
                this.searchForDriver(false);
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    getDriverActivity = (id) => {
        this.props.showSpinner();
        axios.get('api/DriverActivityApi/GetDriverActivityBySalonId?driverId='+id)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.length > 0) {
                    this.setState({ShowRecentActivityModal: true, recentActivityData: res.data});
                } else {
                    this.props.showAlert("تاریخچه‌ای برای راننده مورد نظر پیدا نشد", "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    getDriverToFreighter = (id) => {
        this.props.showSpinner();
        axios.get('/api/v1/driver-to-freighters/GetByDriverId?DriverId=' + id)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.length > 0) {
                    this.setState({ ShowDriverToFreighterModal: true, DriverToFreighterData: res.data.data });
                    console.log(res.data.data);
                } else {
                    this.props.showAlert("ناوگانی‌ برای راننده مورد نظر پیدا نشد", "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    GetDriverPicture = (nationId) => {
        this.props.showSpinner();
        axios.get('api/v1/drivers/GetDriverPicture?nationId=' + nationId)
            .then((res) => {
                this.props.hideSpinner();
                let base64ImageString = Buffer.from(res.data, 'binary').toString('base64');
                if (res.data.length > 0) {
                    this.setState({
                        ShowImageModal: true,
                        ShowImage: "data:image/png;base64," + base64ImageString
                    });
                } else {
                    this.props.showAlert("تصویری برای راننده مورد نظر پیدا نشد", "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });

        if (modalName === "DriverInformationModal" || modalName === "ChargeModal") {
            this.searchForDriver(false);
        }
    };

    selectHandleChange = (event, value, name) => {
        if (name === "selectedDriverSearchType") {
            this.reset();
        }

        this.setState({[name]: value });
    };
    openModal = (modalName, item) => {
        if (modalName === "ShowDriverToFreighterModal") { 
             this.getDriverToFreighter(item.id);
        }
         
        if (modalName === "ShowAddFreighterModal" || modalName === "ChargeModal" || modalName === "ShowAccountActivityModal" ) { 
            this.setState({
                [modalName]: true,
                oneDriver: item
            } );
        }
         
        
    }
    GetRateByDriverId = (DriverId) => {
        this.props.showSpinner();
        axios.get('/api/v1/driver-rates/GetRateByDriverId?DriverId=' + DriverId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    if (res.data.data.length != null && res.data.data.length > 0) {
                        this.setState({ DriverRateList: res.data.data, AvrageRate: res.data.data[0].avrageRate, DriverRateListMsg: "" });
                        //console.log(res.data.data);
                    } else {
                        this.setState({ DriverRateList: [], DriverRateListMsg: "درخواستی وجود ندارد" });
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };
    deletephone = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('api/v1/drivers/EmptyPhoneId?driverId=' + id, null)
            .then(() => {
                this.props.showAlert(" حذف با موفقیت انجام شد", 'success');
                this.searchForDriver(false);
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                                <CardTitle>جستجوی راننده</CardTitle> 
                                    <div className="p-4 pt-5 border d-flex flex-column">
                                        <div className="d-flex flex-md-row flex-column justify-content-center">
                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>جستجو بر اساس</Label>
                                                <Autocomplete
                                                    disableClearable
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedDriverSearchType"
                                                    options={this.state.driverSearchTypes}
                                                    getOptionLabel={(option) => option.text}
                                                    value={this.state.selectedDriverSearchType}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedDriverSearchType")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-30 w-100 px-1">
                                                    <Label>جستجو</Label>
                                                    <Input value={this.state.search} onChange={(e) => this.setState({search: e.target.value})}/>
                                            </FormGroup>
                                        </div>

                                        {this.state.errors.length === 0 ?
                                            null
                                            :
                                            <div>
                                                {(this.state.errors.map((error, i) => {
                                                    return (
                                                        <Alert color="danger" key={i}>{error}</Alert>
                                                    )
                                                }))}
                                            </div>
                                        }

                                        <div className="d-flex mt-2 justify-content-center">
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={() => this.validateInputData(true)}>
                                                    جستجو
                                                </Button>
                                            </FormGroup>
                                        </div>
                                    </div>

                                {this.state.driverSearchResult !== null && this.state.driverSearchResult.length > 0 ?
                                    <Table
                                        tableHeaders={[
                                            "شناسه",
                                            "نام کامل",
                                            "کد ملی",
                                            "موبایل",
                                            "هوشمند راننده",

                                            "تاریخ",
                                            "ساعت",
                                            // "وضعیت لاگین",
                                            "اطلاعات",

                                            "رمز عبور",
                                            "تغییر وضعیت",
                                            "ناوگان ها",
                                            "افزودن ناوگان",
                                            "شارژ",
                                            "گزارش کیف پول",
                                            "حذف شناسه موبایل",
                                            // "وضعیت بومی",
                                            // "بومی/غیر بومی",
                                            // "نمايش امتياز",
                                        ]}

                                        tableRow={this.state.driverSearchResult}

                                        tableData={[
                                            x => {
                                                return x.id
                                            },
                                            x => {
                                                return x.name + " " + x.family
                                            },
                                            x => {
                                                return x.nationalId
                                            },
                                            x => {
                                                return x.mobile
                                            },
                                            x => {
                                                return x.cardNumber
                                            },

                                            x => {
                                                return x.registerDate;
                                            },
                                            x => {
                                                return x.registerTime;
                                            },
                                            // x => {
                                            //     if (x.driverLogin) {
                                            //         return (
                                            //             <Button outline color="danger" size="sm"
                                            //                 onClick={() => this.props.showSweetAlert("آیا این راننده از اپ خارج شود؟", "", "danger", () => this.LogOutDriver(x.id, false))}>
                                            //                 خروج
                                            //             </Button>
                                            //         )
                                            //     }
                                            //     else return <Badge color="danger" pill>وارد نشد</Badge>
                                            // },
                                            x => {
                                                return (
                                                    <Button outline color="info" size="sm"
                                                        onClick={() => this.setState({ oneDriver: x, DriverInformationModal: true })}>
                                                        تغيير شماره موبايل
                                                    </Button>
                                                )
                                            },

                                            x => {
                                                return (
                                                    <Button outline color="info" size="sm"
                                                        onClick={() => this.setState({ oneDriver: x, ChangePassModal: true })}>
                                                        تغییر
                                                    </Button>
                                                )
                                            },
                                            x => {
                                                if (x.driverActive === false) {
                                                    return (
                                                        <Button outline color="success" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا این راننده فعال شود؟", "", "success", () => this.Active(x.id))}>
                                                            فعال کردن
                                                        </Button>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <Button outline color="danger" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا این راننده غیر فعال شود؟", "", "danger", () => this.Deactive(x.id))}>
                                                            غیر فعال کردن
                                                        </Button>
                                                    )
                                                }
                                            },
                                            x => {
                                                return (

                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("ShowDriverToFreighterModal", x)}>
                                                        ناوگان ها
                                                    </Button>

                                                )
                                            },
                                            x => {
                                                return (

                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("ShowAddFreighterModal", x)}>
                                                        افزودن ناوگان
                                                    </Button>

                                                )
                                            },
                                            x => {
                                                return (

                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("ChargeModal", x)}>
                                                        شارژ
                                                    </Button>

                                                )
                                            },
                                            x => {
                                                return (

                                                    <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("ShowAccountActivityModal", x)}>
                                                        ليست تراكنش ها
                                                    </Button>

                                                )
                                            },
                                            x => {
                                               
                                                    return (
                                                        <Button outline color="danger" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا شناسه موبایل راننده حذف شود؟", "", "danger", () => this.deletephone(x.id))}>
                                                            حذف شناسه موبایل
                                                        </Button>
                                                    )
                                                 
                                            },
                                            // x => {

                                            //     if (x.isNative === false) {
                                            //         return( "غیر بومی"   )
                                            //     }
                                            //     else {
                                            //         return("بومی" )
                                            //     }
                                            // },
                                            // x => {

                                            //     if (x.isNative === false) {
                                            //         return(
                                            //         <Button outline color="danger" size="sm"
                                            //             onClick={() => this.props.showSweetAlert("آیا این راننده  بومی شود؟", "", "danger", () => this.NativeDriver(x.id,true))}>
                                            //             بومی
                                            //             </Button>
                                            //             )
                                            //     }
                                            //     else {
                                            //         return(
                                            //         <Button outline color="danger" size="sm"
                                            //             onClick={() => this.props.showSweetAlert("آیا این راننده غير بومی شود؟", "", "danger", () => this.NativeDriver(x.id,false))}>
                                            //             غير بومی
                                            //             </Button>
                                            //             )
                                            //     }
                                            // },
                                            // x => {
                                            //     return (
                                            //         <Button outline color="primary" size="sm"
                                            //             onClick={() => this.setState({ DriverRateModal: true, DriverRateList: [], DriverRateListMsg: "" }, () => this.GetRateByDriverId(x.id)
                                            //             )}>
                                            //             نمایش امتياز
                                            //         </Button>

                                            //     )
                                            // }
                                        ]}
                                    />
                                    :
                                    null
                                }
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>


                <Modal isOpen={this.state.DriverInformationModal} toggle={() => this.closeModal("DriverInformationModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("DriverInformationModal")}>
                        اطلاعات راننده :
                        {" "}
                        {this.state.oneDriver && this.state.oneDriver.name}
                        {" "}
                        {this.state.oneDriver && this.state.oneDriver.family}
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-center">
                        <DriverInformation
                            driver={this.state.oneDriver}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            hideAlert={this.props.hideAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>

                
                <Modal isOpen={this.state.ChargeModal} toggle={() => this.closeModal("ChargeModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ChargeModal")}>
                        شارژ اعتبار راننده
                    </ModalHeader>
                    <ModalBody>
                        <ChargeDriver
                            driver={this.state.oneDriver}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.ShowAccountActivityModal} toggle={() => this.closeModal("ShowAccountActivityModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ShowAccountActivityModal")}>
                        لیست تراکنش‌های مالی راننده
                    </ModalHeader>
                    <ModalBody>
                        <PersonAccountActivities
                            id={this.state.oneDriver.id}
                            role="Driver"
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ChangePassModal} toggle={() => this.closeModal("ChangePassModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ChangePassModal")}>
                        تغییر رمز عبور راننده
                    </ModalHeader>
                    <ModalBody>
                        <ChangePassDriver
                            driver={this.state.oneDriver}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.UpdateTurnModal} toggle={() => this.closeModal("UpdateTurnModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("UpdateTurnModal")}>
                        فعال شدن نوبت راننده
                    </ModalHeader>
                    <ModalBody>
                        <UpdateDriverTurn
                            driver={this.state.oneDriver}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ShowRecentActivityModal} toggle={() => this.closeModal("ShowRecentActivityModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ShowRecentActivityModal")}>
                        تاریخچه فعالیت‌های راننده
                    </ModalHeader>
                    <ModalBody>
                        <DriverRecentActivity
                            recentActivityData={this.state.recentActivityData}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.ShowDriverToFreighterModal} toggle={() => this.closeModal("ShowDriverToFreighterModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ShowDriverToFreighterModal")}>
                        ليست ناوگانها
                    </ModalHeader>
                    <ModalBody>
                        <DriverToFreighter
                            DriverToFreighterData={this.state.DriverToFreighterData}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.ShowAddFreighterModal} toggle={() => this.closeModal("ShowAddFreighterModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ShowAddFreighterModal")}>
                        افزودن ناوگان و تغيير اطلاعات ناوگان
                    </ModalHeader>
                    <ModalBody>
                        <AddFreighter
                            oneDriver={this.state.oneDriver}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ShowImageModal} toggle={() => this.setState({ ShowImageModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ ShowImageModal: false })}>
                        تاریخچه فعالیت‌های راننده
                    </ModalHeader>
                    <ModalBody>
                        <img alt="" width="50px" height="50px" src={this.state.ShowImage} />
                        <img src={`data:image/jpeg;base64,${this.state.ShowImage}`} />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.DriverRateModal} toggle={() => this.setState({ DriverRateModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ DriverRateModal: false })}>
                        {this.state.DriverRateListMsg}
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-center">

                        <Table
                            tableHeaders={[
                                "نام محموله",
                                "مبدا",
                                "مقصد",
                                "امتياز",
                                "توضیحات امتیاز"

                            ]}

                            tableRow={this.state.DriverRateList}

                            tableData={[
                                x => {
                                    return x.kalaDesc
                                },

                                x => {
                                    return x.cargoSource
                                },
                                x => {
                                    return x.cargoDestination
                                },
                                x => {
                                    return x.rate
                                },
                                x => {
                                    return x.desc
                                },
                            ]} />


                    </ModalBody>

                    <ModalFooter >
                        <p className="pl-4">امتياز:{this.state.AvrageRate} </p>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}
